export interface Anchor {
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
  width?: string;
  transform?: string;
}

/** A bordered box. The visual vocabulary of the whole genre. */
export class GameWindow {
  readonly el: HTMLDivElement;

  constructor(parent: HTMLElement, className = "", id?: string) {
    this.el = document.createElement("div");
    this.el.className = `ds-window hidden ${className}`.trim();
    if (id) this.el.id = id;
    parent.appendChild(this.el);
  }

  get visible(): boolean {
    return !this.el.classList.contains("hidden");
  }

  show(): this {
    this.el.classList.remove("hidden");
    return this;
  }

  hide(): this {
    this.el.classList.add("hidden");
    return this;
  }

  setHTML(html: string): this {
    this.el.innerHTML = html;
    return this;
  }

  setText(text: string): this {
    this.el.textContent = text;
    return this;
  }

  anchor(anchor: Anchor): this {
    const s = this.el.style;
    s.left = anchor.left ?? "";
    s.right = anchor.right ?? "";
    s.top = anchor.top ?? "";
    s.bottom = anchor.bottom ?? "";
    s.width = anchor.width ?? "";
    s.transform = anchor.transform ?? "";
    return this;
  }

  destroy(): void {
    this.el.remove();
  }
}
